import { useState, useEffect, useRef } from "react";
import { useMobileOrientation } from "react-device-detect";

export enum Orientation {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape",
}

export function useOrientation() {
  const removed = useRef(false);
  const [orientation, setOrientation] = useState<Orientation>(Orientation.PORTRAIT);

  useEffect(() => {
    const orientationCheck = () => {
      setTimeout(() => {
        if (!removed.current) {
          if (matchMedia("all and (orientation: landscape)").matches) {
            setOrientation(Orientation.LANDSCAPE);
          } else {
            setOrientation(Orientation.PORTRAIT);
          }
        }
      }, 100);
    };

    orientationCheck();

    window.addEventListener("orientationchange", orientationCheck, false);

    return () => {
      window.removeEventListener("orientationchange", orientationCheck);
      removed.current = true;
    };
  }, []);

  const mobileOrientation = useMobileOrientation();

  if (typeof matchMedia !== "function") {
    return mobileOrientation;
  }

  return {
    orientation,
    isLandscape: orientation === Orientation.LANDSCAPE,
    isPortrait: orientation === Orientation.PORTRAIT,
  };
}
